var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonTabs',{attrs:{"id":_vm.$props.id,"resource":"template-libraries","tabs":_vm.tabs,"components":_vm.components,"default-router":_vm.defaultRouter,"item-for-permission":_vm.templateLibrary,"breadcrumbs":_vm.breadcrumbs}})}
var staticRenderFns = []

export { render, staticRenderFns }